import { Timestamp } from '@griply/types';
import { addDays, startOfDay } from 'date-fns';

// Stored endDate is exclusive (start of the day after the last occurrence); the user-facing date is one day earlier.
export const getDisplayEndDate = (endDate?: Timestamp | null): Date | null =>
  endDate ? startOfDay(addDays(endDate, -1)) : null;

export const getStoredEndDate = (
  displayEndDate?: Timestamp | null,
): Date | null =>
  displayEndDate ? startOfDay(addDays(displayEndDate, 1)) : null;
